/**
 * LoadingScreen – fullscreen loading indicator.
 */
export default function LoadingScreen() {
  return (
    <div className="flex items-center justify-center py-20">
      <div className="flex flex-col items-center gap-4">
        <div className="relative w-12 h-12">
          <div className="absolute inset-0 rounded-full border-2 border-slate-800" />
          <div className="absolute inset-0 rounded-full border-2 border-primary-500 border-t-transparent animate-spin" />
        </div>
        <span className="text-slate-500 text-sm">Loading your archive...</span>
      </div>
    </div>
  );
}
